module.exports = __webpack_public_path__ + "iPhone11-White@2x.png?1e717105ccb989cd6957b30078fa5f7a";